import { graphql } from "react-relay";
import { AvatarRow } from "@components/avatar";

export const suggestionBodyWeeklyAutopilotSummaryFragments = {
  org: graphql`
    fragment SuggestionBodyWeeklyAutopilotSummary_org on Org
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      ...AvatarRow_org
      id
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          ...AvatarRow_personList
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  suggestionPayload: graphql`
    fragment SuggestionBodyWeeklyAutopilotSummary_suggestionPayload on SuggestionResultPayload {
      ... on SuggestionResultWeeklyAutopilotSummaryPayload {
        historicalDefragBenefitScore {
          totalFocusTimeSavings
          conflictsResolved
          affectedCalendars
          meetingsMoved
        }
        dateRangeMin
        dateRangeMax
      }
    }
  `,
};

export const refetchQuery = graphql`
  query SuggestionBodyWeeklyAutopilotSummaryQuery($orgRelayId: ID!, $calendarIds: [String]!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...SuggestionBodyWeeklyAutopilotSummary_org @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
